export function ExternalPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold">External Page</h1>
        <p className="text-muted-foreground">This is an external page</p>
      </div>
    </div>
  );
}
